import { render } from "./Security.vue?vue&type=template&id=5b9e2cad"
import script from "./Security.vue?vue&type=script&lang=js"
export * from "./Security.vue?vue&type=script&lang=js"

import "./Security.vue?vue&type=style&index=0&id=5b9e2cad&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__